export const PROMOCODE_ROUTE = "/promocode";
